// src/request/api/fighter/editCharacteristics.ts
import { EditFighterCharacteristicsDto } from "../../../model/Dto/Fighter";
import { ApiRequest, RequestMethod } from "../../request";

export async function editCharacteristics(
  fighterId: string,
  data: EditFighterCharacteristicsDto
): Promise<boolean> {
  const apiRequest = new ApiRequest();

  const URL = `/api/fighter/${fighterId}/edit-characteristics`;

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);
  apiRequest.setJsonBody(data);

  const response: any = await apiRequest.send();

  return response.status === 200;
}